/* @ngInject */
const storageHandler = (
  $window
) => {
  const self = {}

  self.clear = () => {
    const jwtToken = self.get('jwtToken')
    const username = self.get('username')
    $window.localStorage.clear()
    self.save('jwtToken', jwtToken)
    self.save('username', username)
  }

  self.save = (key, value) => {
    $window.localStorage[key] = JSON.stringify(value)
  }

  self.get = (key) => {
    const value = $window.localStorage[key]
    if (!value) return null
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  }

  return self
}
export default storageHandler



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/utils/storageHandler.js